import React from 'react';
import './key-selection-button.scss';
import { ReactComponent as KeyIcon } from 'assets/icons/key.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';

interface IKeySelectionButton {
  onClick: () => void;
  keyName?: string;
  onClearKey: () => void;
}

export default function KeySelectionButton({
  onClick,
  keyName,
  onClearKey,
}: IKeySelectionButton) {
  return (
    <div className="key-selection-button">
      <div
        className="flex align-center cursor-pointer"
        role="button"
        onClick={onClick}
      >
        <KeyIcon className="mr_16" />
        {keyName ? (
          <div>
            <span className="p p_font-size_12 p_color_light-grey">
              Выберите Ключ
            </span>
            <span className="p p_color_grey">{keyName}</span>
          </div>
        ) : (
          <span className="p p_color_grey">Выберите Ключ</span>
        )}
      </div>
      {keyName && (
        <TrashIcon
          className="ml_16 cursor-pointer"
          role="button"
          onClick={onClearKey}
        />
      )}
    </div>
  );
}
